import {FETCH_BANNERS_REQUEST, FETCH_BANNERS_SUCCES, FETCH_BANNERS_ERROR} from '../constants/Banners'

const initialState = {
  list: [],
  hasErrored: false,
  isLoading: false
}

export default function banners(state = initialState, action) {
  switch (action.type) {
      case FETCH_BANNERS_REQUEST:
        return {...state, isLoading: true};
      case FETCH_BANNERS_SUCCES:
        return {...state, list: action.payload.results, isLoading: false};
      case FETCH_BANNERS_ERROR:
        return {...state, hasErrored: true, isLoading: false};
      default:
          return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/banners.js